import TournamentCard from "./TournamentCard";
import PrizeDistribution from "./PrizeDistribution";
import Sponsor from "./Sponsor";
import LiveRankings from "./LiveRankings";
import Button from "../../ReusableComponent/Button";

const TournamentDetails = ({ tournamentData }) => {
  return (
    <div className="container-fluid py-5 my-5">
      {/* Back Button */}
      <div className="mb-3">
        <Button variant="back">
          ← Back to Tournaments
        </Button>
      </div>

      <div className="row mx-0 d-flex justify-content-center align-items-center">
        <div className="col-md-11 col-12 mb-4">
          <div className="row mx-0 d-flex justify-content-center align-items-center">
            {/* Left: Tournament Info */}
            <div className="col-md-8 col-12">
              <TournamentCard
                title={tournamentData.title}
                badges={tournamentData.badges}
                prizePool={tournamentData.prizePool}
                description={tournamentData.description}
                startsIn={tournamentData.startsIn}
                participants={tournamentData.participants}
                problems={tournamentData.problems}
                rating={tournamentData.rating}
                rules={tournamentData.rules}
                categories={tournamentData.categories}
                registerLink={tournamentData.registerLink}
              />
            </div>

            {/* Right: Side Widgets */}
            <div className="col-md-4 col-12 mb-3 d-flex flex-column gap-4">
              <PrizeDistribution prizes={tournamentData.prizes} />
              <Sponsor sponsors={tournamentData.sponsors} />
              <LiveRankings />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TournamentDetails;
